const signupButton = {
  customClasses: {
    marginTop: '0.5em',
    marginBottom: '2.1em',
  },
};

export default signupButton;
